import { IParamsToSend } from '@base/@types/providers/Kpi/LogisticProvider'

export const logisticIndicatorsRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  fornecedor: {
    ids: [],
    agrupar: true
  },
  subCategoria: {
    ids: [],
    agrupar: false
  },
  periodo: {
    inicio: new Date().toISOString(),
    final: new Date().toISOString(),
    agrupar: false
  }
}
